export default "images/实时路线导航+风险物体提示+前车风险提示.png";